/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { DatePipe } from '@angular/common'
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
@Component({
  selector: 'app-slp-date-picker',
  templateUrl: './slp-date-picker.component.html',
  styleUrls: ['./slp-date-picker.component.scss'],
})
class SlpDatePickerComponent {
  constructor(public datePipe: DatePipe) {}

  @Input() public set dateValue(value: string) {
    this.date = value
    this.dateInputValue = this.datePipe.transform(this.date, 'MM/dd/yyyy')
  }
  public date: string
  @Output() dateValueChange: EventEmitter<any> = new EventEmitter<any>()

  clearAll() {
    this.dateInput.nativeElement.value = ''
    this.date = null
    this.dateValueChange.emit(this.date)
  }

  @ViewChild('dateInput') dateInput
  dateInputValue: string

  changeInputDate() {
    if (this.dateInputValue) {
      try {
        const dateValue =  this.dateInputValue.replace(/\D/g, '').replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3')

        if(dateValue.length >= 10){
          const newDate = new Date(dateValue)
          this.date = newDate.toISOString()
          this.dateValueChange.emit(this.date)
        }
        else if(dateValue?.length === 0){
          this.clearAll()
        }
      } catch {
        console.log(`Invalid date: ${this.dateInputValue}`)
        this.clearAll()
      }
    }
  }

  setDateInputValue() {
    this.dateInputValue = this.datePipe.transform(this.date, 'MM/dd/yyyy')
    this.dateValueChange.emit(this.date)
  }

  onBlurInputDate() {
    if (this.dateInputValue && this.dateInputValue.length != 10) {
      this.clearAll()
    }
  }
}

export { SlpDatePickerComponent }
